import * as React from "react";
const SvgSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, fill: "currentColor" }));
export default SvgSquare;
